<template>
  <div class="flex flex-col min-h-screen bg-tertiary">
    <main-menu />
    <div class="flex-1 pt-16 lg:pt-32 pb-7 px-5 max-w-xl md:max-w-7xl mx-auto">
      <slot />
    </div>
    <Footer />
  </div>
</template>

<script>
import MainMenu from '@/Shared/MainMenu'
import Footer from '@/Shared/Footer'

export default {
  components: {
    MainMenu,
    Footer,
  },
  data() {
    return {
      isRetina: false,
    }
  },
  methods: {
    setIsRetina: function () {
      if (window.devicePixelRatio > 1) {
        this.isRetina = true
      } else {
        var mediaQuery = '(-webkit-min-device-pixel-ratio: 1.5), (min--moz-device-pixel-ratio: 1.5), (-o-min-device-pixel-ratio: 3/2), (min-resolution: 1.5dppx)'
        this.isRetina = !!(window.matchMedia && window.matchMedia(mediaQuery).matches)
      }
    },
  },
}
</script>
